<template>
  <div style="display: flex; align-items: center; padding: 0 8px">
    <div style="display: flex; margin-right: 14px; margin-left: auto">
      <div style="font-size: 12px; display: flex; align-items: center">Elementos por página</div>
      <v-select v-model="select" @change="setItemsPerPage" :items="items" hide-details height="32px" class="pt-0" style="margin: 13px 0 13px 34px; min-width: 45.48px; max-width: 52.22px"></v-select>
    </div>
    <div style="font-size: 12px; display: flex; margin: 0 32px 0 24px; height: 18px">
      Página {{ page === 1 ? 1 : (page - 1) * select + 1 }} - {{ Math.min(page * select, itemsLength) }} de {{ itemsLength }}
    </div>
    <div style="width: 43px">
      <v-btn @click="lastClic" icon :disabled="page === 1 ? true : false" style="margin-right: 7px">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </div>

    <div style="width: 43px">
      <v-btn @click="nextClic" icon :disabled="Math.min(page * select, itemsLength) === itemsLength ? true : false" style="margin-left: 7px">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    page: {
      type: Number, // Tipo de dato de la propiedad page
      required: true, // Indicar si es requerida o no
    },
    itemsLength: {
      type: Number,
      required: true,
    },
    props: ["itemsPerPage"],
  },
  data: () => ({
    select: "10",
    items: ["10", "50", "100", "200"],
  }),
  methods: {
    setItemsPerPage() {
      // Emitir evento con el dato como argumento
      this.$emit("sendItemsPerPage", this.select);
    },
    lastClic() {
      // Emitir evento al componente padre
      this.$emit("lastClic");
    },
    nextClic() {
      // Emitir evento al componente padre
      this.$emit("nextClic");
    },
  },
};
</script>

<style>
.v-select__selection--comma {
  font-size: 0.75rem;
}
.v-select.v-text-field:not(.v-text-field--single-line) input {
  display: none;
}
</style>
